import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
@Component
export class HeroBanner extends ThemeComponent {

}
